/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/user.type';

export const getUserLicenses = () => ({
  type: actions.GET_USER_LICENSES,
});

export const getUserLicensesSuccess = (data: any) => ({
  type: actions.GET_USER_LICENSES_SUCCESS,
  payload: data,
});

export const getUserLicensesFailure = (error: any) => ({
  type: actions.GET_USER_LICENSES_FAILURE,
  payload: error,
});

export const getUserHasPermission = (data: any) => ({
  type: actions.GET_USER_HAS_PERMISSION,
  payload: data,
});

export const getUserHasPermissionSuccess = (data: any) => ({
  type: actions.GET_USER_HAS_PERMISSION_SUCCESS,
  payload: data,
});

export const getUserHasPermissionFailure = (error: any) => ({
  type: actions.GET_USER_HAS_PERMISSION_FAILURE,
  payload: error,
});
